import React from "react";
import { CollectionCarousel } from "../../index.js";
export default function MoreInThisCollectionCarousel(_ref) {
  var ProductCardsInfo = _ref.ProductCardsInfo,
    mobileSlidesToShow = _ref.mobileSlidesToShow,
    desktopSlidesToShow = _ref.desktopSlidesToShow,
    mobileWidth = _ref.mobileWidth,
    mobileHeight = _ref.mobileHeight,
    desktopWidth = _ref.desktopWidth,
    desktopHeight = _ref.desktopHeight,
    heading = _ref.heading,
    collection = _ref.collection,
    gutter = _ref.gutter,
    isMobile = _ref.isMobile;
  return /*#__PURE__*/React.createElement(CollectionCarousel, {
    ProductCardsInfo: ProductCardsInfo,
    mobileSlidesToShow: mobileSlidesToShow,
    desktopSlidesToShow: desktopSlidesToShow,
    mobileWidth: mobileWidth,
    mobileHeight: mobileHeight,
    desktopWidth: desktopWidth,
    desktopHeight: desktopHeight,
    heading: heading,
    collection: collection,
    gutter: gutter,
    isMobile: isMobile
  });
}